import { render, staticRenderFns } from "./provComp.vue?vue&type=template&id=180f8bb3"
import script from "./provComp.vue?vue&type=script&lang=js"
export * from "./provComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports